import { render, staticRenderFns } from "./PropBatchEditDialog.vue?vue&type=template&id=481eb32f&scoped=true&"
import script from "./PropBatchEditDialog.vue?vue&type=script&lang=js&"
export * from "./PropBatchEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481eb32f",
  null
  
)

export default component.exports